import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import type { AppState } from 'lib/redux'
import { baseRESTUrl } from 'lib/utils'
import { Field } from './types'

export interface CreatorCardState {
  bio: any,
}

const initialState: CreatorCardState = {
  bio: {
    [Field.name]: '',
    [Field.email]: '',
    [Field.description]: '',
    [Field.phone]: '',
    [Field.website]: '',
    [Field.instagram]: '',
    [Field.facebook]: '',
    [Field.linkedin]: '',
    [Field.twitter]: '',
  },
}

export const getPackBio = createAsyncThunk(
  'creatorCard/getBio',
  async (packId: string, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${baseRESTUrl()}/v1/packs/${packId}/bio`, { withCredentials: true });
      dispatch(setBio(data));
      return data;
    } catch (err) {
      return rejectWithValue('Could not get bio');
    }
  }
)

export const getBio = createAsyncThunk(
  'creatorCard/getBio',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${baseRESTUrl()}/v1/bio`, { withCredentials: true });
      dispatch(setBio(data));
      return data;
    } catch (err) {
      return rejectWithValue('Could not get bio');
    }
  }
)

export const updateBio = createAsyncThunk(
  'creatorCard/updateBio',
  async (bio: any, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await axios.put(`${baseRESTUrl()}/v1/bio`, bio, { withCredentials: true });
      dispatch(setBio(data));
      return data;
    } catch (err) {
      return rejectWithValue('Could not update bio');
    }
  }
)

export const creatorCardSlice = createSlice({
  name: 'creatorCard',
  initialState,
  reducers: {
    bio: (state, { payload }) => void(state.bio = payload),
  },
})

export const { bio: setBio } = creatorCardSlice.actions;

export const selectBio = (state: AppState) => state.creatorCard.bio;
